export default {
  name: '',
  password: '',
  profile_image_key: null,
  settings: {
    'notifications.enabled': true
  }
}
